/**
 * EligibilityBadges — Reusable position eligibility display.
 * Reads effective_eligibility from the player object (backend-computed).
 * No fallback — if the field is missing, that's a backend bug to fix.
 *
 * Usage: <EligibilityBadges player={player} />
 *        <EligibilityBadges player={player} size="sm" />
 */
import React from 'react';

const EligibilityBadges = ({ player, size = 'md' }) => {
  if (!player) return null;

  const primary = player.info?.position;
  const positions = player.league_context?.roster?.effective_eligibility;

  if (!positions || !positions.length) return null;

  const isSm = size === 'sm';
  const fontSize = isSm ? '8px' : '10px';
  const padding = isSm ? '1px 3px' : '2px 6px';
  const gap = isSm ? '2px' : '4px';

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap, flexWrap: 'wrap' }}>
      {positions.map(pos => (
        <span
          key={pos}
          style={{
            fontSize,
            fontWeight: 600,
            padding,
            borderRadius: '3px',
            color: pos === primary ? '#eab308' : '#a3a3a3',
            backgroundColor: pos === primary ? 'rgba(234,179,8,0.12)' : 'rgba(64,64,64,0.5)',
            border: pos === primary ? '1px solid rgba(234,179,8,0.3)' : '1px solid rgba(82,82,82,0.5)',
            lineHeight: 1,
          }}
        >
          {pos}
        </span>
      ))}
    </div>
  );
};

export default EligibilityBadges;
